import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

import { ConfigService } from 'src/app/shared/services/config.service';
import { MetaService } from 'src/app/shared/services/meta.service';
import { MockAPIProvider } from 'src/app/shared/services/mock-api.provider';

import { Jumbotron } from 'ascedia-design-system/lib/models/jumbotron.interface';
import { SwiperCardImage } from 'ascedia-design-system/lib/models/swiper-card-image.interface';


@Component({
	selector: 'app-general-error',
	templateUrl: './general-error.component.html'
})
export class GeneralErrorComponent implements OnInit {

	public idOrSlug: string;

	public jumbotron$: Observable<Jumbotron>;
	public taBody$: Observable<any>;
	public sliderListPopular$: Observable<SwiperCardImage[]>;
	
	public favsList: any[];

	public breakpoints = {
		//lowest setting is in markup
		640: { slidesPerView: 2.25, slidesPerGroup: 2, spaceBetween: 10 },
		991: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 }
	};

	constructor(
		private _mockAPIProvider: MockAPIProvider,
		private _configService: ConfigService,
		private _metaService: MetaService,
		private route: ActivatedRoute
	) { }

	ngOnInit(): void {
		this.idOrSlug = this.route.snapshot.queryParamMap.get('idOrSlug');
		//console.log('load product.idOrSlug:', this.idOrSlug);

		this._metaService.updateMetaData('Error');

		this.sliderListPopular$ = this._mockAPIProvider.load('main/home-slider-popular.json', false)
		.pipe(map((res: SwiperCardImage[]) => {
			if(res && res.length > 0) {
				//console.log('sliderListPopular$:', res);
				res.forEach(item => {
					//item.image += Math.floor(Math.random()*10000);
					item.image = '/assets/images/home/' + item.image;
					item.image2x = '/assets/images/home/' + item.image2x;
				});
				this.checkSwiperFavs(res);
				return res;
			}
			return null;
		}));

		this.taBody$ = this._mockAPIProvider.load('main/general-error-body.json', false)
			.pipe(map((res: any) => {
				//console.log('taBody$:', res);
				if(res) {
					//console.log('taBody:', res);
					return res;
				}
				return null;
			}));
	}


	/**
	 * Check swipers against favs
	 * @param items 
	*/
	public checkSwiperFavs(items: SwiperCardImage[]) {
		items.forEach(item => {
			const isFavorite = this.favsList?.includes(item.id);
			//console.log('checkFavs.item.id:', item.id, isFavorite);
			item.isFavorite = isFavorite;
		});
	}

}
